import { StateToken } from '@ngxs/store';

export const REWARDFUL_STATE_TOKEN = new StateToken<RewardfulStateModel>('rewardful');

export interface RewardfulStateModel {
  referralId: string | null;
  couponId: string | null;
  couponName: string | null;
  couponDuration: string | null;
  couponPercentOff: string | null;
  affiliateId: string | null;
  affiliateName: string | null;
  campaignId: string | null;
  campaignName: string | null;
}
